import React from "react";
import "../../Css/About.css";

const About = () => {
  return (
    <section className="about-section">
      <div className="about-glow"></div>

      <div className="about-container">
        {/* Heading Section */}
        <div className="about-top">
          <div className="about-badge">
            <span className="about-dot"></span>
            ABOUT ELITENOVA
          </div>

          <h2 className="about-title">
            About <span>EliteNova</span>
          </h2>

          <p className="about-description">
            We combine cutting-edge technology with creative design to deliver
            exceptional digital experiences that drive business growth.
          </p>
        </div>

        {/* Cards Section */}
        <div className="about-cards">
          {/* Mission */}
          <div className="about-card">
            <div className="card-icon">🚀</div>

            <h3>Our Mission</h3>

            <p>
              Empower businesses with scalable, innovative digital solutions
              that accelerate growth.
            </p>
          </div>

          {/* Vision */}
          <div className="about-card">
            <div className="card-icon">🌍</div>

            <h3>Our Vision</h3>

            <p>
              Be the leading software company trusted by businesses worldwide
              for premium digital transformation.
            </p>
          </div>

          {/* Commitment */}
          <div className="about-card">
            <div className="card-icon">💎</div>

            <h3>Our Commitment</h3>

            <p>
              Deliver exceptional quality, responsive design, and dedicated
              support for every project.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;